import React, { useContext, useEffect, useState } from 'react'
import SspContext from '../../../../../contexts/SspContext'
import { IDepositData } from '../../../../../interfaces/i-api-creaditCard'
import { checkIsMobile } from 'shared'
import InfoBox from './InfoBox/InfoBox'

const DepositOverview = () => {
	const isMobile = checkIsMobile()

	const { overviewData, error } = useContext(SspContext)
	const [depositData, setDepositData] = useState(overviewData as IDepositData)
	const [depositInfo, setDepositInfo] = useState<string[]>([])

	useEffect(() => {
		if (depositData?.note) {
			let index = depositData.note.indexOf('Bic')
			let indexIban = depositData.note.substr(0, index).indexOf(':')
			let indexBic = depositData.note.substr(index + 1).indexOf(':')

			setDepositInfo([
				depositData.note.substr(0, index).substr(indexIban + 1),
				depositData.note.substr(index + 1).substr(indexBic + 1),
			])
		}
	}, [depositData])

	useEffect(() => {
		setDepositData(overviewData as IDepositData)
	}, [overviewData])

	let containerCls = ['fade-in', 'container', 'd-flex', 'mt-4']
	if (isMobile) containerCls.push('flex-column')

	return (
		<>
			{!error && (
				<div className={containerCls.join(' ')}>
					<InfoBox
						depositData={depositData}
						depositInfo={depositInfo}
					/>
				</div>
			)}
		</>
	)
}
export default DepositOverview
